module.exports = __webpack_public_path__ + "static/media/UniversLTStd-Light.cdbb3eed.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/UniversLTStd-Light.eot
// module id = 75
// module chunks = 0